<template>
  <ap-header class="flex-nowrap bg-white" @menu="$emit('click:menu')" :breakpoint="breakpoint">
    <TheTabsHeader
      v-if="
        route.meta?.headerType &&
          [HEADER_TYPE.SETTINGS, HEADER_TYPE.ACCOUNT, HEADER_TYPE.STATS].includes(
            route.meta?.headerType
          )
      " />
    <TheMainHeader v-else />
  </ap-header>
</template>

<script setup>
import { useRoute } from "vue-router"
import TheMainHeader from "@/components/TheMainHeader.vue"
import TheTabsHeader from "@/components/TheTabsHeader.vue"
import { HEADER_TYPE } from "@/interfaces/header"
import { computed } from "vue"

defineEmits(["click:menu"])
const route = useRoute()
const breakpoint = computed(() => (route.meta.layout?.sidebarCollpased ? null : undefined))
</script>

<style></style>
